import { render, staticRenderFns } from "./ShopOrder.vue?vue&type=template&id=bb13cedc&scoped=true"
import script from "./ShopOrder.vue?vue&type=script&lang=js"
export * from "./ShopOrder.vue?vue&type=script&lang=js"
import style0 from "./ShopOrder.vue?vue&type=style&index=0&id=bb13cedc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb13cedc",
  null
  
)

export default component.exports